module.exports = __webpack_public_path__ + "img/index-section6-friend9_a.61caefe8.svg";